import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    const res = await fetch((process.env.REACT_APP_API_BASE || '') + '/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    if (res.ok) {
      const { token } = await res.json();
      localStorage.setItem('token', token);
      localStorage.setItem('lastActivity', Date.now().toString()); // Track activity for auto-logout
      window.location.href = '/admin';
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 via-indigo-600 to-purple-700 pt-24">
      <div className="relative w-full max-w-md">
        <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 via-pink-400 to-cyan-400 rounded-3xl blur opacity-40"></div>
        <div className="relative bg-white rounded-3xl shadow-2xl p-8">
          <div className="text-center mb-6">
            <div className="text-3xl font-extrabold bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent">Admin Portal</div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="mt-1 w-full rounded-xl border border-gray-200 p-3 focus:ring-2 focus:ring-purple-500 outline-none" />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Password</label>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="mt-1 w-full rounded-xl border border-gray-200 p-3 focus:ring-2 focus:ring-purple-500 outline-none" />
            </div>
            <button type="submit" className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold py-3 rounded-xl hover:shadow-lg transition-transform hover:scale-[1.01]">
              Sign In
            </button>
          </form>
          <div className="text-center mt-4">
            <Link to="/admin/forgot-password" className="text-sm text-purple-600 hover:text-purple-800 font-medium">
              Forgot Password?
            </Link>
          </div>
          <div className="text-center text-xs text-gray-500 mt-4">© 2025 BuildYourDevOps</div>
        </div>
      </div>
    </div>
  );
}


